var map = {
	"./add_icon.svg": "58f2",
	"./back_icon.svg": "fc99",
	"./checkbox.svg": "0128",
	"./checkbox_checked.svg": "9fc9",
	"./close_modal.svg": "f745",
	"./edit-2.svg": "7bf8",
	"./login_google.svg": "ab6d",
	"./login_vk.svg": "e63f",
	"./open_filters.svg": "63a4",
	"./open_icon.png": "a130",
	"./plus_circle.svg": "4476",
	"./trash-2.svg": "dfb0",
	"./x-circle.svg": "5728"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4003";